/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').image, // @acavan!
    user = require('./user');

module.exports = Backbone.Model.extend({
    sync: function (method, model, options) {
        const url = configuration.apiUrlBase + 'programImage/',
            ajax = function (ajaxOptions) {
                jQuery.ajax(_.extend({
                    contentType: 'application/json',
                    dataType: 'json',
                    error: options.error,
                    headers: user.authorizationHeader('image'),
                    success: options.success
                }, ajaxOptions));
            },
            methods = {
                create: function () {
                    ajax({
                        data: JSON.stringify(model.toJSON()),
                        method: 'POST',
                        url: url
                    });
                },
                delete: function () {
                    ajax({
                        method: 'DELETE',
                        url: url + model.id
                    });
                },
                update: function () {
                    ajax({
                        data: JSON.stringify(model.changed),
                        method: 'PUT',
                        url: url + model.id
                    });
                }
            };
        if (methods[method]) {
            methods[method](options);
        } else {
            Backbone.sync.apply(this, arguments);
        }
    }
});
